import { Link } from 'react-router-dom'
import { BRAND } from '../constants/brand'
import type { InquiryFormLayoutProps } from '../constants/inquiries'
import { InquiryHeroArt } from './InquiryHeroArt'
import '../styles/inquiry-page.scss'

export function InquiryFormLayout({
  variant,
  eyebrow,
  title,
  lead,
  highlights,
  formTitle,
  formLead,
  children,
}: InquiryFormLayoutProps) {
  return (
    <div className={`inquiry-page inquiry-page--${variant}`}>
      <section className="inquiry-hero">
        <div className="container inquiry-hero__inner">
          <div className="inquiry-hero__copy">
            <Link to="/" className="inquiry-hero__brand" aria-label={BRAND.homeAria}>
              <img src={BRAND.logoSrc} alt="" width={160} height={42} />
              <span>{BRAND.logoAlt}</span>
            </Link>
            {eyebrow ? <p className="inquiry-hero__eyebrow">{eyebrow}</p> : null}
            <h1>{title}</h1>
            <p className="inquiry-hero__lead">{lead}</p>
            {highlights?.length ? (
              <ul className="inquiry-hero__highlights">
                {highlights.map((item) => (
                  <li key={item.id}>{item.label}</li>
                ))}
              </ul>
            ) : null}
          </div>
          <div className="inquiry-hero__art">
            <InquiryHeroArt variant={variant} />
          </div>
        </div>
      </section>

      <section className="inquiry-body">
        <div className="container">
          <div className="inquiry-card">
            {formTitle ? (
              <header className="inquiry-card__header">
                <h2>{formTitle}</h2>
                {formLead ? <p>{formLead}</p> : null}
              </header>
            ) : null}
            {children}
          </div>
        </div>
      </section>
    </div>
  )
}
